export default __webpack_public_path__ + "static/9_29-b55f125f6507540866dbfd9342dcf9a0.png";